var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiClient } from "./BaseApiClient";
import { TypeExtends } from "sb-js-extends";
TypeExtends();
export var RACES_ENDPOINTS = {
    BY_ID: "/Races/{0}",
    ALL: "/Races",
    COMPACT: "/Races/Compact"
};
/**
 * RacesApiClient - client for fetching races from BFF
 * @exports
 * @class RacesApiClient
 * @extends BaseApiClient
 */
var RacesApiClient = /** @class */ (function (_super) {
    __extends(RacesApiClient, _super);
    function RacesApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get a race by race id from BFF
     * @param {string} raceId id of a race
     * @throws {RequiredError}
     * @memberof RacesApiClient
     */
    RacesApiClient.prototype.getById = function (raceId) {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(RACES_ENDPOINTS.BY_ID.format(raceId), fetchOptions);
    };
    /**
     * Get races by league id from BFF
     * @throws {RequiredError}
     * @memberof RacesApiClient
     */
    RacesApiClient.prototype.getRaces = function (request) {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        var queryItems = request.leagueIds ? request.leagueIds.map(function (x) { return "LeagueIds=" + x; }) : [];
        request.paginationTop && queryItems.push("Pagination.Top=" + request.paginationTop);
        request.paginationSkip && queryItems.push("Pagination.Skip=" + request.paginationSkip);
        var queryString = queryItems.join("&");
        return this.executeRequest(RACES_ENDPOINTS.ALL + ("?" + queryString), fetchOptions);
    };
    /**
     * Get all races with no participants and tote details from BFF
     * @throws {RequiredError}
     * @memberof RacesApiClient
     */
    RacesApiClient.prototype.getRacesCompact = function () {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(RACES_ENDPOINTS.COMPACT, fetchOptions);
    };
    return RacesApiClient;
}(BaseApiClient));
export { RacesApiClient };
//# sourceMappingURL=RacesApiClient.js.map